<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex flex-column flex-md-row align-items-start justify-content-md-between">
        <div class="mb-0">
          <h1 class="page-title">Notes</h1>
          <h2 class="page-subtitle">Total : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" class="text-nowrap">
          <plus-icon size="18" class="mr-1" /> Ajouter une note
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableNote"
          identifier="B122TableNote"
          init-b122-table-url="/note/initB122Table"
          get-b122-table-results-url="/note/getB122TableResults"
          :fields="tableFields"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >

          <template #cell(title)="data">
            <span> {{ data.title ? data.title : '-' }} </span>
          </template>

        </b122-table>

      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <note-delete-modal :selected="ui.selected" @didDeleteNote="didDeleteNote()"></note-delete-modal>

  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import NoteDeleteModal from "./NoteDeleteModal";

export default {

  name: 'NoteIndex',

  components: {
    B122Table,
    NoteDeleteModal
  },

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: "Date",
          key: "creationDate",
          sortable: true,
          formatter: function (value, key, item) {
            var date = new Date(value)
            return date.toLocaleString()
          }
        },
        {
          label: "Animal",
          key: "animal.name",
          sortKey: "hospitalization.animal.name",
          sortable: true
        },
        {
          label: "Propriétaire",
          key: "animal.user.name",
          sortKey: "hospitalization.animal.user.lastName",
          sortable: true
        },
        {
          label: "Titre",
          key: "title",
          sortable: true
        },
        {
          label: "Type",
          key: "type",
          sortable: true
        },
        {
          label: "",
          key: "actions"
        }
      ],
      ui: {
        selected: null
      }
    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'NoteCreate'
      })            },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'NoteShow',
        params: {
          noteId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'NoteEdit',
        params: {
          noteId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selected = row.item
      this.$bvModal.show('note-delete-modal')
    },

    didDeleteNote() {
      this.ui.selected = null;
      this.$refs.B122TableNote.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/note/NoteIndex.vue